module.exports = __webpack_public_path__ + "img/smartNotas.0752cd00.svg";